import { z } from "zod";
import apiClient from "../../../shared/api/client";
import type { CloudStreamsListResponse } from "../types";

const restreamLinkSchema = z.object({
  destinationId: z.string().nullable().optional(),
  platform: z.string(),
  uri: z.string(),
  key: z.string().nullable().optional(),
  restreamId: z.string().nullable().optional(),
  active: z.boolean(),
});

const cloudStreamSchema = z.object({
  id: z.string(),
  userId: z.number().nullable(),
  name: z.string(),
  cloudStreamId: z.string().nullable(),
  ingestUrl: z.string().nullable(),
  rtmpStreamKey: z.string().nullable(),
  srtStreamKey: z.string().nullable(),
  status: z.enum([
    "creating",
    "active",
    "paused",
    "stopped",
    "error",
    "archived",
  ]),
  playlistId: z.string().nullable(),
  restreamLinks: z.array(restreamLinkSchema).default([]),
  autoRecordEnabled: z.boolean(),
  planId: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const cloudStreamsListResponseSchema = z.object({
  data: z.array(cloudStreamSchema),
});

export const fetchCloudStreams =
  async (): Promise<CloudStreamsListResponse> => {
    const response = await apiClient.get("/cloud-streams");
    return cloudStreamsListResponseSchema.parse(response.data);
  };

export const deleteCloudStream = async (id: string): Promise<void> => {
  await apiClient.delete(`/cloud-streams/${id}`);
};
